import {useContext, useMemo} from 'react';

import {CaptchaContext} from '../CaptchaContext';

type Payload =
  | {placement: string; error: false}
  | {
      placement: string;
      error: true;
      errorMessage: string;
    };

export const createErrorMessageForAnalytics = (
  errorDetail: unknown,
): string => {
  let errorStr = '';
  if (typeof errorDetail === 'number') {
    errorStr = `fetch_status_${errorDetail}`;
  } else if (errorDetail instanceof Error) {
    errorStr = ['error', errorDetail.name, errorDetail.message].join('_');
  } else {
    errorStr = `${errorDetail}`;
  }

  return errorStr.substring(0, 255);
};

const convertPayloadToParams = (payload: Payload): Record<string, string> => ({
  form_name: payload.placement,
  response: payload.error ? 'failure' : 'success',
  text: payload.error ? payload.errorMessage : '',
});

export const useLogVkCaptchaEvents = () => {
  const {logAnalyticsEvent} = useContext(CaptchaContext);

  return useMemo(
    () => ({
      logInitResult: (payload: Payload) =>
        logAnalyticsEvent({
          logEvent: 'captcha.initialization',
          params: convertPayloadToParams(payload),
        }),

      logSdkCallResult: (payload: Payload) =>
        logAnalyticsEvent({
          logEvent: 'captcha.click',
          params: convertPayloadToParams(payload),
        }),

      logValidationResult: (payload: Payload) =>
        logAnalyticsEvent({
          logEvent: 'captcha.validationResult',
          params: convertPayloadToParams(payload),
        }),
    }),
    [logAnalyticsEvent],
  );
};
